export default __webpack_public_path__ + "static/media/icon-id-doc.9b04b192.svg";